export default __webpack_public_path__ + "static/media/book-read-user-white.284bd694.svg";